import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { withQuery, withMutation } from '../../../hoc/withGraphql';
import getReviewsForModeration from './getReviewsForModeration.graphql';
import moderateReviewM from './moderateReview.graphql';

const RED = '#D32F2F';
const PAGE_SIZE = 15;

class ReviewModerationPage extends Component {
  constructor(props) {
    super(props);
    this.state = { statusFilter: '', currentPage: 1, busy: false, message: '' };
  }

  vars() { return { currentPage: this.state.currentPage, statusFilter: this.state.statusFilter || undefined }; }
  refetch = () => this.props.reviews.refetch(this.vars());
  apply = () => this.setState({ currentPage: 1 }, this.refetch);
  go = (d) => this.setState((s) => ({ currentPage: Math.max(1, s.currentPage + d) }), this.refetch);

  moderate = async (reviewId, vars, label) => {
    this.setState({ busy: true, message: '' });
    try {
      const res = await this.props.moderate({ variables: { reviewId, ...vars } });
      const r = res && res.data && res.data.moderateReview;
      if (r && r.status === 200) { this.setState({ busy: false, message: `✅ ${label}.` }); this.refetch(); }
      else this.setState({ busy: false, message: (r && r.errorMessage) || 'Failed.' });
    } catch (e) { this.setState({ busy: false, message: e.message }); }
  };

  reply = (reviewId, current) => {
    const text = window.prompt('Public admin reply to this review:', current || '');
    if (text === null) return;
    this.moderate(reviewId, { adminReply: text }, 'Reply saved');
  };

  render() {
    const list = (this.props.reviews && this.props.reviews.getReviewsForModeration) || {};
    const rows = list.results || [];
    const loading = this.props.reviews && this.props.reviews.loading;
    const totalPages = Math.max(1, Math.ceil((list.count || 0) / PAGE_SIZE));

    const input = { padding: '8px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginRight: 8 };
    const btn = (bg) => ({ background: bg, color: '#fff', border: 'none', padding: '6px 12px', borderRadius: 8, fontWeight: 600, cursor: 'pointer', marginRight: 6, fontSize: 13 });
    const th = { padding: 10, textAlign: 'left' };
    const td = { padding: 10, borderTop: '1px solid #f0f0f0', fontSize: 13, verticalAlign: 'top' };
    const badge = (s) => {
      const c = { visible: '#2E7D32', hidden: '#9E9E9E', flagged: '#F9A825' }[s] || '#9E9E9E';
      return { padding: '2px 9px', borderRadius: 999, fontSize: 11, fontWeight: 700, color: '#fff', background: c };
    };

    return (
      <div style={{ fontFamily: 'Poppins, sans-serif' }}>
        <h1 className="siteAdminPrimaryHeading">Review Moderation</h1>

        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 14, marginBottom: 14 }}>
          <select style={input} value={this.state.statusFilter} onChange={(e) => this.setState({ statusFilter: e.target.value })}>
            <option value="">All reviews</option>
            <option value="visible">Visible</option>
            <option value="hidden">Hidden</option>
            <option value="flagged">Flagged</option>
          </select>
          <button style={btn(RED)} onClick={this.apply}>Apply</button>
          {this.state.message ? <span style={{ marginLeft: 12, color: RED, fontWeight: 600 }}>{this.state.message}</span> : null}
        </div>

        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead><tr style={{ background: '#fafafa' }}>
              <th style={th}>Rating</th><th style={th}>Review</th><th style={th}>Author</th><th style={th}>Provider</th><th style={th}>Status</th><th style={th}>Actions</th>
            </tr></thead>
            <tbody>
              {loading && <tr><td style={td} colSpan={6}>Loading…</td></tr>}
              {!loading && rows.length === 0 && <tr><td style={td} colSpan={6}>No reviews.</td></tr>}
              {!loading && rows.map((r) => (
                <tr key={r.id}>
                  <td style={td}>{r.rating} ★</td>
                  <td style={{ ...td, maxWidth: 320 }}>{r.content || '—'}{r.adminReply ? <div style={{ color: '#1565C0', marginTop: 4 }}>↳ {r.adminReply}</div> : null}</td>
                  <td style={td}>{r.authorName}</td>
                  <td style={td}>{r.providerName}</td>
                  <td style={td}><span style={badge(r.status)}>{r.status}</span></td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>
                    {r.status !== 'hidden'
                      ? <button style={btn('#9E9E9E')} disabled={this.state.busy} onClick={() => this.moderate(r.id, { status: 'hidden' }, 'Hidden')}>Hide</button>
                      : <button style={btn('#2E7D32')} disabled={this.state.busy} onClick={() => this.moderate(r.id, { status: 'visible' }, 'Shown')}>Show</button>}
                    {r.status !== 'flagged' && <button style={btn('#F9A825')} disabled={this.state.busy} onClick={() => this.moderate(r.id, { status: 'flagged' }, 'Flagged')}>Flag</button>}
                    <button style={btn('#1565C0')} disabled={this.state.busy} onClick={() => this.reply(r.id, r.adminReply)}>Reply</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ marginTop: 14, display: 'flex', alignItems: 'center', gap: 12 }}>
          <button style={btn(RED)} disabled={this.state.currentPage <= 1} onClick={() => this.go(-1)}>Prev</button>
          <span>Page {this.state.currentPage} / {totalPages} ({list.count || 0})</span>
          <button style={btn(RED)} disabled={this.state.currentPage >= totalPages} onClick={() => this.go(1)}>Next</button>
        </div>
      </div>
    );
  }
}

export default compose(
  withQuery(getReviewsForModeration, { name: 'reviews', options: { variables: { currentPage: 1 }, fetchPolicy: 'network-only', ssr: false } }),
  withMutation(moderateReviewM, { name: 'moderate' }),
)(ReviewModerationPage);
